const BASE = "/api/items";

export async function getItems() {
  const res = await fetch(BASE);
  if (!res.ok) throw new Error("Failed to load items");
  return res.json();
}
